import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import AssignmentIcon from '@mui/icons-material/Assignment';
import { StatusBadge } from "../../../../../../common/Badge";

const TransactionModalHeader = ({ onClose, isViewOnly, status }) => (
  <div className="flex justify-between items-center px-6 py-3 border-b bg-gray-50 rounded-t-lg">
    <h2 className="text-lg font-bold text-blue-900 flex items-center gap-2 box-border">
      <AssignmentIcon /> {isViewOnly ? "View Employee Transaction" : "Employee Transactions Entry"} 
      <div className="flex items-center gap-2">
        <StatusBadge status={status || "Draft"} />
      </div>
    </h2>
    <button onClick={onClose} className="text-gray-400 hover:text-red-500 bg-transparent border-none cursor-pointer">
      <CloseIcon />
    </button>
  </div>
);

export default TransactionModalHeader;